var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "fill-white",
      attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 48" },
    },
    [
      _c("title", [_vm._v("Go to icon for hero component")]),
      _vm._v(" "),
      _c("path", { attrs: { d: "M3,32l2,2L3,36,1,34Z" } }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M.45,25l2.47,2.47L5.4,25,2.93,22.53Z" } }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M3,18l3-3L3,12,0,15Z" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }